import React from 'react';
import { useHistory } from 'react-router-dom';
import { HeaderAuth } from './template/index';
import HomeCard from './HomeCard';
import api from '../services/api';
import { Error, Success } from './Alert/index';

export default function Home () {
  const [error, setError] = React.useState(false);
  const [success] = React.useState(false);
  const [permissions, setPermissions] = React.useState([]);
  const history = useHistory();

  React.useEffect(() => {
    api.get('/permissions')
      .then((res) => setPermissions(res.data))
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        }
      });
  }, [history]);
  return (
    <>
      <HeaderAuth />
      {error ? <Error><p id="msgError" /></Error> : null}
      {success ? <Success><p id="msgSuccess" /></Success> : null}
      <div className="content-home">
        {permissions.map((component) => (
          component.route !== '/'
            ? (
              <HomeCard
                key={component._id}
                route={component.route}
                image={component.thumbnail_url}
                title={component.name}
                text={component.description}
              />
            )
            : null
        ))}

      </div>
    </>
  );
}
